// import React, { Component } from "react";
// import { Link } from "react-router-dom";
// import parse from "html-react-parser";

// class ContactForm extends Component {
//   componentDidMount() {
//     const $ = window.$;

//     // Get the form.
//     var form = $("#contact-form");

//     // Get the messages div.
//     var formMessages = $(".form-messege");

//     // Set up an event listener for the contact form.
//     $(form).submit(function (e) {
//       // Stop the browser from submitting the form.
//       e.preventDefault();

//       // Serialize the form data.
//       var formData = $(form).serialize();

//       // Submit the form using AJAX.
//       $.ajax({
//         type: "POST",
//         url: $(form).attr("action"),
//         data: formData,
//       })
//         .done(function (response) {
//           // Make sure that the formMessages div has the 'success' class.
//           $(formMessages).removeClass("error");
//           $(formMessages).addClass("success");

//           // Set the message text.
//           $(formMessages).text(response);

//           // Clear the form.
//           $("#contact-form input,#contact-form textarea").val("");
//         })
//         .fail(function (data) {
//           // Make sure that the formMessages div has the 'error' class.
//           $(formMessages).removeClass("success");
//           $(formMessages).addClass("error");

//           // Set the message text.
//           if (data.responseText !== "") {
//             $(formMessages).text(data.responseText);
//           } else {
//             $(formMessages).text(
//               "Oops! An error occured and your message could not be sent."
//             );
//           }
//         });
//     });
//   }

//   render() {
//     let publicUrl = process.env.PUBLIC_URL + "/";

//     return (
//       <div className="ltn__contact-message-area mb-120">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <div className="ltn__form-box contact-form-box box-shadow white-bg">
//                 <h4 className="title-2">Get A Quote</h4>
//                 <form
//                   id="contact-form"
//                   action={publicUrl + "mail.php"}
//                   method="post"
//                 >
//                   <div className="row">
//                     <div className="col-md-6">
//                       <div className="input-item input-item-name ltn__custom-icon">
//                         <input
//                           type="text"
//                           name="name"
//                           placeholder="Enter your name"
//                         />
//                       </div>
//                     </div>
//                     <div className="col-md-6">
//                       <div className="input-item input-item-email ltn__custom-icon">
//                         <input
//                           type="email"
//                           name="email"
//                           placeholder="Enter email address"
//                         />
//                       </div>
//                     </div>
//                     <div className="col-md-6">
//                       <div className="input-item">
//                         <select className="nice-select" name="service">
//                           <option>Solar Inverter</option>
//                           <option>Solar Battery </option>
//                           <option>E-Bike Batteries </option>
//                         </select>
//                       </div>
//                     </div>
//                     <div className="col-md-6">
//                       <div className="input-item input-item-phone ltn__custom-icon">
//                         <input
//                           type="text"
//                           name="phone"
//                           placeholder="Enter phone number"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                   <div className="input-item input-item-textarea ltn__custom-icon">
//                     <textarea
//                       name="message"
//                       placeholder="Enter message"
//                       defaultValue={""}
//                     />
//                   </div>
//                   <p>
//                     <label className="input-info-save mb-0">
//                       <input type="checkbox" name="agree" /> Save my name,
//                       email, and website in this browser for the next time I
//                       comment.
//                     </label>
//                   </p>
//                   <div className="btn-wrapper mt-0">
//                     <button
//                       className="btn theme-btn-1 btn-effect-1 text-uppercase"
//                       type="submit"
//                     >
//                       get a free service
//                     </button>
//                   </div>
//                   <p className="form-messege mb-0 mt-20" />
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// export default ContactForm;

// Old Email Work

// import React, { useState } from "react";
// import { ToastContainer, toast } from "react-toastify";
// import {
//   FaUser,
//   FaEnvelope,
//   FaPhone,
//   FaCity,
//   FaCommentDots,
// } from "react-icons/fa";

// const ContactForm = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     city: "",
//     customer_type: "",
//     product: "",
//     message: "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({ ...prevData, [name]: value }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const formElements = e.target.elements;
//     const customerType = formElements.customer_type.value;
//     const product = formElements.product.value;

//     const updatedFormData = {
//       ...formData,
//       customer_type: customerType,
//       product: product,
//     };

//     console.log(updatedFormData, "data------");

//     const missingField = Object.entries(updatedFormData).find(
//       ([key, value]) => !value || value.trim() === ""
//     );

//     if (missingField) {
//       const fieldName = missingField[0]
//         .replace(/_/g, " ")
//         .replace(/\b\w/g, (l) => l.toUpperCase());
//       toast.error(`${fieldName} is missing`);
//       return;
//     }

//     toast.success("Form submitted successfully!");
//     console.log("Form Data Submitted:", updatedFormData);
//   };

//   return (
//     <>
//       <ToastContainer
//         position="top-center"
//         hideProgressBar={false}
//         newestOnTop={true}
//         closeOnClick
//         pauseOnHover
//         theme="colored"
//       />

//       <div className="ltn__contact-message-area mb-120">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <div className="ltn__form-box contact-form-box box-shadow white-bg">
//                 <h4 className="title-2">Get A Quote</h4>
//                 <form id="contact-form" onSubmit={handleSubmit}>
//                   <div className="row">
//                     <div className="col-md-6 position-relative">
//                       <div className="input-item ">
//                         <input
//                           type="text"
//                           name="name"
//                           placeholder="Enter your name"
//                           value={formData.name}
//                           onChange={handleChange}
//                         />
//                         <FaUser
//                           style={{
//                             position: "absolute",
//                             right: "15px",
//                             top: "38%",
//                             transform: "translateY(-50%)",
//                             color: "#004d40",
//                           }}
//                         />
//                       </div>
//                     </div>
//                     <div className="col-md-6 position-relative">
//                       <div className="input-item ">
//                         <input
//                           type="email"
//                           name="email"
//                           placeholder="Enter email address"
//                           value={formData.email}
//                           onChange={handleChange}
//                         />
//                         <FaEnvelope
//                           style={{
//                             position: "absolute",
//                             right: "15px",
//                             top: "38%",
//                             transform: "translateY(-50%)",
//                             color: "#004d40",
//                           }}
//                         />
//                       </div>
//                     </div>

//                     <div className="col-md-6 position-relative">
//                       <div className="input-item ">
//                         <input
//                           type="text"
//                           name="phone"
//                           placeholder="Enter phone number"
//                           value={formData.phone}
//                           onChange={handleChange}
//                         />
//                         <FaPhone
//                           style={{
//                             position: "absolute",
//                             right: "15px",
//                             top: "38%",
//                             transform: "translateY(-50%)",
//                             color: "#004d40",
//                           }}
//                         />
//                       </div>
//                     </div>

//                     <div className="col-md-6 position-relative">
//                       <div className="input-item ">
//                         <input
//                           type="text"
//                           name="city"
//                           placeholder="Enter your city"
//                           value={formData.city}
//                           onChange={handleChange}
//                         />
//                         <FaCity
//                           style={{
//                             position: "absolute",
//                             right: "15px",
//                             top: "38%",
//                             transform: "translateY(-50%)",
//                             color: "#004d40",
//                           }}
//                         />
//                       </div>
//                     </div>

//                     <div className="col-md-6 position-relative">
//                       <div className="input-item">
//                         <select
//                           className="nice-select"
//                           name="customer_type"
//                           defaultValue=""
//                         >
//                           <option value="">Customer Type</option>
//                           <option value="User">User</option>
//                           <option value="Dealer">Dealer</option>
//                           <option value="Distributor">Distributor</option>
//                           <option value="Installer">Installer</option>
//                           <option value="Others">Others</option>
//                         </select>
//                       </div>
//                     </div>

//                     <div className="col-md-6 position-relative">
//                       <div className="input-item">
//                         <select
//                           className="nice-select"
//                           name="product"
//                           defaultValue=""
//                         >
//                           <option value="">Product</option>
//                           <option value="Solar Batteries">
//                             Solar Batteries
//                           </option>
//                           <option value="Solar Inverters">
//                             Solar Inverters
//                           </option>
//                           <option value="Solar Panels">Solar Panels</option>
//                           <option value="EV Batteries">EV Batteries</option>
//                         </select>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="input-item input-item-textarea  position-relative">
//                     <textarea
//                       name="message"
//                       placeholder="Enter message"
//                       value={formData.message}
//                       onChange={handleChange}
//                     />
//                     <FaCommentDots
//                       style={{
//                         position: "absolute",
//                         right: "15px",
//                         top: "15px",
//                         color: "#004d40",
//                       }}
//                     />
//                   </div>

//                   <div className="btn-wrapper mt-0">
//                     <button
//                       className="btn theme-btn-1 btn-effect-1 text-uppercase"
//                       type="submit"
//                     >
//                       Send
//                     </button>
//                   </div>

//                   <p className="form-messege mb-0 mt-20" />
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ContactForm;

// New Email with email js

// import React, { useState } from "react";
// import emailjs from "emailjs-com";
// import { ToastContainer, toast } from "react-toastify";
// import {
//   FaUser,
//   FaEnvelope,
//   FaPhone,
//   FaCity,
//   FaCommentDots,
// } from "react-icons/fa";
// import PhoneInput from "react-phone-input-2";

// const ContactForm = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     city: "",
//     customer_type: "",
//     product: "",
//     message: "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({ ...prevData, [name]: value }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const formElements = e.target.elements;
//     const customerType = formElements.customer_type.value;
//     const product = formElements.product.value;

//     const updatedFormData = {
//       ...formData,
//       customer_type: customerType,
//       product: product,
//     };

//     const missingField = Object.entries(updatedFormData).find(
//       ([key, value]) => !value || value.trim() === ""
//     );

//     if (missingField) {
//       const fieldName = missingField[0]
//         .replace(/_/g, " ")
//         .replace(/\b\w/g, (l) => l.toUpperCase());
//       toast.error(`${fieldName} is missing`);
//       return;
//     }

//     // Send email via EmailJS
//     emailjs
//       .sendForm(
//         "service_0ig6gnt", // Your Service ID
//         "template_9sn1p1b", // Your Template ID
//         e.target, // Form element
//         "1FhTCgiOGzh5End4v" // 🔑 Replace this with your actual Public Key from EmailJS
//       )
//       .then(
//         (result) => {
//           console.log("Email sent:", result.text);
//           toast.success("Form submitted and email sent!");
//         },
//         (error) => {
//           console.error("Email error:", error.text);
//           toast.error("Something went wrong while sending email.");
//         }
//       );

//     e.target.reset(); // Optional: clear form
//   };

//   return (
//     <>
//       <ToastContainer
//         position="top-center"
//         hideProgressBar={false}
//         newestOnTop={true}
//         closeOnClick
//         pauseOnHover
//         theme="colored"
//       />

//       <div className="ltn__contact-message-area mb-120">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <div className="ltn__form-box contact-form-box box-shadow white-bg">
//                 <h4 className="title-2">Submit a Query</h4>
//                 <form id="contact-form" onSubmit={handleSubmit}>
//                   <div className="row">
//                     <div className="col-md-6 position-relative">
//                       <div className="input-item">
//                         <input
//                           type="text"
//                           name="name"
//                           placeholder="Enter your name"
//                           value={formData.name}
//                           onChange={handleChange}
//                         />
//                         <FaUser
//                           style={{
//                             position: "absolute",
//                             right: "15px",
//                             top: "38%",
//                             transform: "translateY(-50%)",
//                             color: "#004d40",
//                           }}
//                         />
//                       </div>
//                     </div>
//                     <div className="col-md-6 position-relative">
//                       <div className="input-item">
//                         <input
//                           type="email"
//                           name="email"
//                           placeholder="Enter email address"
//                           value={formData.email}
//                           onChange={handleChange}
//                         />
//                         <FaEnvelope
//                           style={{
//                             position: "absolute",
//                             right: "15px",
//                             top: "38%",
//                             transform: "translateY(-50%)",
//                             color: "#004d40",
//                           }}
//                         />
//                       </div>
//                     </div>

//                     <div className="col-md-6 position-relative">
//                       {/* <div className="input-item">
//                         <input
//                           type="text"
//                           name="phone"
//                           placeholder="Enter phone number"
//                           value={formData.phone}
//                           onChange={handleChange}
//                         />
//                         <FaPhone
//                           style={{
//                             position: "absolute",
//                             right: "15px",
//                             top: "38%",
//                             transform: "translateY(-50%)",
//                             color: "#004d40",
//                           }}
//                         />
//                       </div> */}

//                       <div className="input-item mb-4">
//                         <PhoneInput
//                           country={"pk"} // Default country is Pakistan
//                           value={formData.phone}
//                           onChange={(phone) =>
//                             setFormData((prevData) => ({ ...prevData, phone }))
//                           }
//                           inputProps={{
//                             name: "phone",
//                             required: true,
//                           }}
//                           inputStyle={{
//                             width: "100%",
//                             paddingLeft: "52px", // for spacing with flag icon
//                             height: "64px",
//                           }}
//                           buttonStyle={{
//                             borderTopLeftRadius: "4px",
//                             borderBottomLeftRadius: "4px",
//                           }}
//                         />
//                         <FaPhone
//                           style={{
//                             position: "absolute",
//                             right: "15px",
//                             top: "50%",
//                             transform: "translateY(-50%)",
//                             color: "#004d40",
//                           }}
//                         />
//                       </div>
//                     </div>

//                     <div className="col-md-6 position-relative">
//                       <div className="input-item">
//                         <input
//                           type="text"
//                           name="city"
//                           placeholder="Enter your city"
//                           value={formData.city}
//                           onChange={handleChange}
//                         />
//                         <FaCity
//                           style={{
//                             position: "absolute",
//                             right: "15px",
//                             top: "38%",
//                             transform: "translateY(-50%)",
//                             color: "#004d40",
//                           }}
//                         />
//                       </div>
//                     </div>

//                     <div className="col-md-6 position-relative">
//                       <div className="input-item">
//                         <select
//                           className="nice-select"
//                           name="customer_type"
//                           defaultValue=""
//                         >
//                           <option value="">Customer Type</option>
//                           <option value="User">User</option>
//                           <option value="Dealer">Dealer</option>
//                           <option value="Distributor">Distributor</option>
//                           <option value="Installer">Installer</option>
//                           <option value="Others">Others</option>
//                         </select>
//                       </div>
//                     </div>

//                     <div className="col-md-6 position-relative">
//                       <div className="input-item">
//                         <select
//                           className="nice-select"
//                           name="product"
//                           defaultValue=""
//                         >
//                           <option value="">Product</option>
//                           <option value="Solar Batteries">
//                             Solar Batteries
//                           </option>
//                           <option value="Solar Inverters">
//                             Solar Inverters
//                           </option>
//                           <option value="Solar Panels">Solar Panels</option>
//                           <option value="EV Batteries">EV Batteries</option>
//                         </select>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="input-item input-item-textarea position-relative">
//                     <textarea
//                       name="message"
//                       placeholder="Enter message"
//                       value={formData.message}
//                       onChange={handleChange}
//                     />
//                     <FaCommentDots
//                       style={{
//                         position: "absolute",
//                         right: "15px",
//                         top: "15px",
//                         color: "#004d40",
//                       }}
//                     />
//                   </div>

//                   <div className="btn-wrapper mt-0">
//                     <button
//                       className="btn theme-btn-1 btn-effect-1 text-uppercase"
//                       type="submit"
//                     >
//                       Send
//                     </button>
//                   </div>

//                   <p className="form-messege mb-0 mt-20" />
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ContactForm;

import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import { ToastContainer, toast } from "react-toastify";
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaCity,
  FaCommentDots,
} from "react-icons/fa";
import PhoneInput from "react-phone-input-2";
import Select from "react-select";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    customer_type: "",
    product: "",
    message: "",
  });

  const [mode, setMode] = useState("country");
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [loadingCities, setLoadingCities] = useState(false);

  useEffect(() => {
    fetch("https://countriesnow.space/api/v0.1/countries/positions")
      .then((res) => res.json())
      .then((data) => {
        const countryOptions = data.data.map((item) => ({
          label: item.name,
          value: item.name,
        }));
        setCountries(countryOptions);
      })
      .catch((err) => console.error("Failed to load countries", err));
  }, []);

  const handleCityFlow = async (selected) => {
    if (mode === "country") {
      setSelectedCountry(selected);
      setMode("city");
      setLoadingCities(true); // start loading

      const response = await fetch(
        "https://countriesnow.space/api/v0.1/countries/cities",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ country: selected.value }),
        }
      );

      const data = await response.json();

      const cityOptions = [
        { label: "⬅ Back to Country List", value: "__back" },
        ...(data.data || []).map((city) => ({
          label: city,
          value: `${selected.value}, ${city}`,
        })),
      ];

      setCities(cityOptions);
      setLoadingCities(false); // done loading
    } else {
      if (selected.value === "__back") {
        setMode("country");
        setCities([]);
        setSelectedCountry(null);
        setFormData((prev) => ({ ...prev, city: "" }));
      } else {
        setFormData((prev) => ({ ...prev, city: selected.value }));
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formElements = e.target.elements;
    const customerType = formElements.customer_type.value;
    const product = formElements.product.value;

    const updatedFormData = {
      ...formData,
      customer_type: customerType,
      product: product,
    };

    console.log(updatedFormData, "formdata---");

    const missingField = Object.entries(updatedFormData).find(
      ([key, value]) => !value || value.trim() === ""
    );

    if (missingField) {
      const fieldName = missingField[0]
        .replace(/_/g, " ")
        .replace(/\b\w/g, (l) => l.toUpperCase());
      toast.error(`${fieldName} is missing`);
      return;
    }

    emailjs
      .sendForm(
        "service_0ig6gnt",
        "template_9sn1p1b",
        e.target,
        "1FhTCgiOGzh5End4v"
      )
      .then(
        (result) => {
          console.log("Email sent:", result.text);
          toast.success("Form submitted and email sent!");
        },
        (error) => {
          console.error("Email error:", error.text);
          toast.error("Something went wrong while sending email.");
        }
      );

    e.target.reset();
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
        theme="colored"
      />

      <div className="ltn__contact-message-area mb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__form-box contact-form-box box-shadow white-bg">
                <h4 className="title-2">Submit a Query</h4>
                <form id="contact-form" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 position-relative">
                      <div className="input-item">
                        <input
                          type="text"
                          name="name"
                          placeholder="Enter your name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                        <FaUser style={iconStyle} />
                      </div>
                    </div>

                    <div className="col-md-6 position-relative">
                      <div className="input-item">
                        <input
                          type="email"
                          name="email"
                          placeholder="Enter email address"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        <FaEnvelope style={iconStyle} />
                      </div>
                    </div>

                    <div className="col-md-6 position-relative">
                      <div className="input-item mb-4">
                        <PhoneInput
                          country={"pk"}
                          value={formData.phone}
                          onChange={(phone) =>
                            setFormData((prevData) => ({ ...prevData, phone }))
                          }
                          inputProps={{ name: "phone", required: true }}
                          inputStyle={{
                            width: "100%",
                            paddingLeft: "52px",
                            height: "64px",
                            borderRadius: "0px", // 🔥 removes input field rounding
                          }}
                          buttonStyle={{
                            borderRadius: "0px", // 🔥 removes the flag button rounding
                          }}
                        />
                        <FaPhone style={{ ...iconStyle, top: "50%" }} />
                      </div>
                    </div>

                    <div className="col-md-6 position-relative">
                      <div className="input-item">
                        <Select
                          options={mode === "country" ? countries : cities}
                          isLoading={loadingCities}
                          noOptionsMessage={() =>
                            loadingCities ? "Loading cities..." : "No options"
                          }
                          onChange={handleCityFlow}
                          placeholder={
                            mode === "country"
                              ? "Select Country"
                              : `Select City in ${selectedCountry?.label}`
                          }
                          styles={{
                            control: (base) => ({
                              ...base,
                              height: "64px", // Match your phone input
                              minHeight: "64px", // Ensures consistent size
                              borderRadius: "1px", // Optional: match your theme
                            }),
                            indicatorSeparator: (base) => ({
                              ...base,
                              height: "32px", // Customize the bar height here
                              backgroundColor: "#ccc", // Optional: change bar color
                              marginTop: "16px", // Optional: vertical align
                            }),
                            valueContainer: (base) => ({
                              ...base,
                              height: "64px",
                              display: "flex",
                              alignItems: "center",
                              paddingTop: "2px", // 👈 Add this to fine-tune vertical position
                              paddingBottom: "2px",
                              paddingLeft: "12px",
                              paddingRight: "12px",
                            }),
                            input: (base) => ({
                              ...base,
                              margin: "0px",
                              padding: "0px",
                            }),
                            singleValue: (base) => ({
                              ...base,
                              display: "flex",
                              alignItems: "center",
                            }),
                          }}
                          value={
                            formData.city
                              ? { label: formData.city, value: formData.city }
                              : null
                          }
                          classNamePrefix="react-select"
                        />

                        {/* <FaCity style={iconStyle} /> */}
                      </div>
                    </div>

                    <div className="col-md-6 position-relative">
                      <div className="input-item">
                        <select
                          className="nice-select"
                          name="customer_type"
                          defaultValue=""
                        >
                          <option value="">Customer Type</option>
                          <option value="User">User</option>
                          <option value="Dealer">Dealer</option>
                          <option value="Distributor">Distributor</option>
                          <option value="Installer">Installer</option>
                          <option value="Others">Others</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6 position-relative">
                      <div className="input-item">
                        <select
                          className="nice-select"
                          name="product"
                          defaultValue=""
                        >
                          <option value="">Product</option>
                          <option value="Solar Batteries">
                            Solar Batteries
                          </option>
                          <option value="Solar Inverters">
                            Solar Inverters
                          </option>
                          <option value="Solar Panels">Solar Panels</option>
                          <option value="EV Batteries">EV Batteries</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="input-item input-item-textarea position-relative">
                    <textarea
                      name="message"
                      placeholder="Enter message"
                      value={formData.message}
                      onChange={handleChange}
                    />
                    <FaCommentDots style={{ ...iconStyle, top: "15px" }} />
                  </div>

                  <div className="btn-wrapper mt-0">
                    <button
                      className="btn theme-btn-1 btn-effect-1 text-uppercase"
                      type="submit"
                    >
                      Send
                    </button>
                  </div>

                  <p className="form-messege mb-0 mt-20" />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const iconStyle = {
  position: "absolute",
  right: "15px",
  top: "38%",
  transform: "translateY(-50%)",
  color: "#004d40",
};

export default ContactForm;
